import { render, staticRenderFns } from "./TheIcon.vue?vue&type=template&id=f835dc98&"
import script from "./TheIcon.vue?vue&type=script&lang=js&"
export * from "./TheIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports